<template>
  <div class="c-hero-video">
    <video v-if="isVideoVisible" autoplay muted loop class="c-hero-video__player">
      <source :src="videoUrl.url" type="video/mp4" />
    </video>
  </div>
</template>

<script>
export default {
  props: {
    //   this will be used as a source
    videoUrl: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isVideoVisible: true
    };
  },
  watch: {
    videoUrl() {
      this.toggleVideo();
    }
  },
  methods: {
    toggleVideo() {
      this.isVideoVisible = false;
      this.$nextTick(() => {
        this.isVideoVisible = true;
      });
    }
  }
};
</script>

<style lang="scss">
.c-hero-video {
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  width: 100%;

  z-index: 1;
  overflow: hidden;
  &:before {
    content: " ";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: black;
    opacity: 0.4;
    z-index: 1;
    @media #{$breakpoint-horizontal} {
      opacity: 0.2;
    }
  }
  &__player {
    position: absolute;
    top: 0;
    left: 0;

    object-fit: cover;
    width: 100vw;
    min-height: 100%;

    @media #{$breakpoint-horizontal} {
      width: 100%;
      min-height: 100%;
    }
  }
}
</style>
